import {
    Component, Input, OnInit
} from "@angular/core";

import { Chart } from 'chart.js';
import { Subject } from "rxjs";
import { StatisticsResults } from "../../providers/result/result";
import { WrappedStatistics } from "../../tracker/run-statistics/run-statistics";

/**
 * Generated class for the GoogleMapsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */


@Component({
    selector: "line-chart",
    templateUrl: "line-chart.html",
    styleUrls:['./line-chart.scss']
})
export class LineChartComponent implements OnInit {

    @Input("statistics") statistics: WrappedStatistics;

    @Input("subject") update: Subject<StatisticsResults> = null;

    chart: Chart = null;

    constructor() {

    }

    ngOnInit() {
        this.configureChart()

        if (this.update) this.update.subscribe(() => {
            this.configureChart();
        });
    }

    configureChart() {
        console.log('configureChart: ');
        console.log('this.statistics: ', this.statistics);
        let x = this.statistics.kmStatistics.map(x => x.km);
        console.log('x: ', x);

        let y = this.statistics.kmStatistics.map(y => y.elevation);
        console.log('y: ', y);

        var data = {
            labels: x,
            datasets: [
                {
                    label: '',
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: "#fff",
                    borderColor: "white",
                    borderCapStyle: 'round',
                    borderDash: [],
                    borderDashOffset: 1.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: "white",
                    pointBackgroundColor: "#fff",
                    pointBorderWidth: 1,
                    pointHoverRadius: 5,
                    pointRadius: 1,
                    pointHitRadius: 5,
                    data: y
                }
            ]
        }


        var myLineChart = new Chart("myChart", {
            type: 'line',
            data: data,
            options: {
                scales: {
                    yAxes: [{
                        stacked: false,
                        ticks: {
                            fontColor: '#fff',
                            callback: function (value, index, values) {
                                return value + ' m';
                            }
                        }
                    }],
                    xAxes: [{
                        stacked: true,
                        ticks: {
                            fontColor: '#fff',
                            // Include a dollar sign in the ticks
                            callback: function (value, index, values) {
                                return value + 'km';
                            },
                        }
                    }]
                },
                legend: {
                    display: false
                }
            }
        });
    }
}
